var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCheckboxCheckedBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "6D08B3E1-4507-43DB-B459-BF91FB343A6F")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "email_footer_3",
  transform: "translate(-297.000000, -361.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "email_footer3",
  transform: "translate(32.000000, 301.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Tick",
  transform: "translate(0.000000, 56.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "checkbox_checked",
  transform: "translate(265.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,0 L2,0 C0.9,0 0,0.9 0,2 L0,16 C0,17.1 0.9,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 L16,0 L16,0 Z",
  id: "Shape",
  fill: "#484848"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#000000",
  points: "17 1 17 17 1 17 1 1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.69230769,12.1145318 L6.69584957,12.1111217 L6.69230769,12.1145318 Z M14.3322932,5 L15,5.62497311 L7.44005099,12.6985528 L7.10176706,13 L3,9.16213131 L3.66769707,8.53714907 L7.1099159,11.7579034 L14.3322932,5 Z",
  id: "icon_signedup_tick",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))))))));
export default SvgIconCheckboxCheckedBlack;